module.exports = __webpack_public_path__ + "img/basket-empty-icon.5e4ffbbb.svg";